import { createFileRoute } from "@tanstack/react-router";
import { logout } from "lib/auth";
import Footer from "lib/components/footers/LandingPageFooter";
import InviteForm from "lib/components/home/InviteForm";
import Navbar from "lib/components/home/Navbar";
import { useAppRouterParams } from "lib/routeHelpers";
import { useUserContext } from "lib/state/UserContextProvider";
import getPageTitle from "lib/utils/getPageTitle";
import { useEffect, useState } from "react";
import type { JSX } from "react";
import { Helmet as Head } from "react-helmet-async";
import styles from "../Home.module.scss";

function InvitesPage(): JSX.Element {
  const [mounted, setMounted] = useState(false);
  const { user } = useUserContext();
  const { inviteId } = useAppRouterParams();

  useEffect(() => {
    setMounted(true);

    if (user) {
      void logout(user.id, true);
    }
  }, [user]);

  if (!mounted || !inviteId) {
    return <div style={{ visibility: "hidden" }} />;
  }

  return (
    <div className={styles.wrapper}>
      <Head>
        <title>{getPageTitle("Welcome to Higharc")}</title>
        <meta name="robots" content="noindex" />
      </Head>
      <Navbar />
      <div className="grid-container full-height">
        <InviteForm inviteId={inviteId} />
      </div>
      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/invites/$invite_id")({
  component: InvitesPage,
});
